<template>
  <v-flex class="client-need-want">
    <v-card>
      <v-layout wrap>
        <v-flex v-if="preferenceType === 'Want'">
          <v-card-title class="card-title">
            Wants
            <span @click="openNeedsWantsModal">UPDATE WANTS</span>
          </v-card-title>
        </v-flex>
        <v-flex v-else>
          <v-card-title class="card-title">
            Needs
            <span @click="openNeedsWantsModal">UPDATE NEEDS</span>
          </v-card-title>
        </v-flex>
      </v-layout>
      <v-divider />
      <div class="preference-container">
        <v-chip
          v-for="(item, i) in preferenceArray"
          :key="i"
          class="chips"
          small
          :color="getPreferenceColor"
        >
          {{ item }}
        </v-chip>
      </div>
    </v-card>
    <wants-needs-modal
      :show="showModal"
      :preference-type="preferenceType"
      @close-modal="closeModal"
      @open-confirm-modal="showConfirmModal=true"
    />
    <confirm-modal
      :show="showConfirmModal"
      :text="modalText"
      @close-modal="showConfirmModal=false"
      @click-button="showConfirmModal=false"
    >
      <v-btn
        class="modal-confirm-button modal-confirm-button-cancel white--text"
        :color="colors.secondary"
        round
        @click="closeModal"
      >
        Cancel
      </v-btn>
    </confirm-modal>
  </v-flex>
</template>

<script>
import WantsNeedsModal from '../../modals/WantsNeedsModal'
import ConfirmModal from '../..//modals/ConfirmModal'
import { mapGetters, mapState } from 'vuex'
import { genericGetRequestToApi } from '../../../utils/genericRequests'
import { RetrieveProfileById } from '../../../utils/clientUrls'
import refreshContent from '../../mixins/refreshContent'
import colors from '../../../scss/_colors.scss'

export default {
  components: {
    WantsNeedsModal,
    ConfirmModal
  },
  mixins: [refreshContent],

  props: {
    preferenceType: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      processUpdate: false,
      typedPreference: '',
      preferenceArray: [],
      suggestions: [],
      originalNeedWants: [],
      showConfirmModal: false,
      showModal: false,
      modalText: 'You have unsaved changes. Would you like to cancel it?',
      colors
    }
  },

  computed: {
    ...mapGetters('client', ['getInitialPrefSuggestions', 'feedbackProvidedHomes']),
    ...mapState('client', ['clientData']),

    getPreferenceColor() {
      // Use client side variables here if same color is required
      return this.preferenceType === 'Want' ? colors.hwayzDarkenGreen : colors.hwayzTapestry
    }
  },

  watch: {
    clientData: {
      handler: function(newValue, oldValue) {
        this.preferenceArray = this.getClientHomePreferences(newValue, this.preferenceType)
        if (newValue.homePrefs) this.originalNeedWants = newValue.homePrefs
      },
      deep: true
    }
  },

  created() {
    this.preferenceArray = this.getClientHomePreferences(this.clientData, this.preferenceType)

    genericGetRequestToApi(RetrieveProfileById(this.clientData._id)).then(
      response => {
        if (response.data.homePrefs) this.originalNeedWants = response.data.homePrefs
      }
    )
  },

  methods: {
    getClientHomePreferences(client, preference) {
      this.suggestions = this.getInitialPrefSuggestions.map(preference => preference.text)
      if (client && client.homePrefs) {
        return client.homePrefs.options
          .filter(pref => pref.wantNeed === preference)
          .map(item => {
            if (item.minValue) {
              return item.text + '-' + item.minValue
            }
            return item.text
          })
      }
      return []
    },
    openNeedsWantsModal() {
      this.showModal = true
    },
    closeModal() {
      this.showConfirmModal = false
      this.showModal = false
    }
  }
}
</script>

<style lang="sass" scoped>
.chips
  color: $hwayzWhite !important
  &:hover
    cursor: pointer !important

#save__btn
  margin-top: -5%
  margin-bottom: 5%
.preference-container
  overflow: scroll
  text-align: left
  padding: 0 8px 8px
  height: 270px
.area-label
  display: block
  text-transform: capitalize
  font-size: $hwayzFont1rem4
  margin-bottom: 10px !important
.client-need-want
  min-height: 350px
  max-height: 500px
  height: 100%
  width: 100%
  display: flex
  flex-grow: 1
  align-items: stretch
.client-need-want .v-card
  width: 100%
  height: 100%
  padding-bottom: 3rem
.client-need-want .v-divider
  padding-bottom: 2rem
</style>
